module.exports = __webpack_public_path__ + "img/suppliers.a8e991a9.svg";